"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4886],{

/***/ 17634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87379);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97114);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-decoration: ",
        ";\n  text-underline-offset: 0.1em;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var TooltipText = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-9806f639-0"
}).withConfig({
    componentId: "sc-6c68793f-0"
})(_templateObject(), function(param) {
    var theme = param.theme, decorationColor = param.decorationColor;
    var ref;
    return "underline dotted ".concat((theme === null || theme === void 0 ? void 0 : theme.colors) && decorationColor ? theme.colors[decorationColor] : theme === null || theme === void 0 ? void 0 : (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.textSubtle);
});
/* harmony default export */ __webpack_exports__["Z"] = (TooltipText);


/***/ }),

/***/ 36544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useTooltip_useTooltip; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/LazyMotion/index.mjs
var LazyMotion = __webpack_require__(18522);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/features-animation.mjs + 27 modules
var features_animation = __webpack_require__(55606);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(21190);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/react-popper/lib/esm/usePopper.js + 53 modules
var usePopper = __webpack_require__(66441);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./packages/uikit/src/theme/light.ts
var light = __webpack_require__(93723);
// EXTERNAL MODULE: ./packages/uikit/src/theme/dark.ts
var dark = __webpack_require__(4409);
// EXTERNAL MODULE: ./packages/uikit/src/util/getPortalRoot.ts
var getPortalRoot = __webpack_require__(77382);
// EXTERNAL MODULE: ./packages/uikit/src/util/isTouchDevice.ts
var isTouchDevice = __webpack_require__(46075);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 23 modules
var motion_minimal = __webpack_require__(45962);
;// CONCATENATED MODULE: ./packages/uikit/src/hooks/useTooltip/StyledTooltip.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  &,\n  &::before {\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    border-radius: 2px;\n    z-index: -1;\n  }\n\n  &::before {\n    content: "";\n    transform: rotate(45deg);\n    background: ',
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px;\n  font-size: 16px;\n  line-height: 130%;\n  border-radius: 16px;\n  max-width: 320px;\n  z-index: 101;\n  background: ",
        ";\n  color: ",
        ";\n  box-shadow: ",
        ';\n\n  &[data-popper-placement^="top"] > ',
        ' {\n    bottom: -4px;\n  }\n\n  &[data-popper-placement^="bottom"] > ',
        ' {\n    top: -4px;\n  }\n\n  &[data-popper-placement^="left"] > ',
        ' {\n    right: -4px;\n  }\n\n  &[data-popper-placement^="right"] > ',
        " {\n    left: -4px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Arrow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3db373e4-0"
}).withConfig({
    componentId: "sc-178cc10c-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.tooltip.background;
});
var StyledTooltip = (0,styled_components_browser_esm/* default */.ZP)(motion_minimal.m.div).withConfig({
    componentId: "sc-3db373e4-1"
}).withConfig({
    componentId: "sc-178cc10c-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.tooltip.background;
}, function(param) {
    var theme = param.theme;
    return theme.tooltip.text;
}, function(param) {
    var theme = param.theme;
    return theme.tooltip.boxShadow;
}, Arrow, Arrow, Arrow, Arrow);

;// CONCATENATED MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx













var animationVariants = {
    initial: {
        opacity: 0
    },
    animate: {
        opacity: 1
    },
    exit: {
        opacity: 0
    }
};
var animationMap = {
    initial: "initial",
    animate: "animate",
    exit: "exit"
};
var invertTheme = function invertTheme(currentTheme) {
    if (currentTheme.isDark) {
        return light/* default */.Z;
    }
    return dark/* default */.Z;
};
var useTooltip = function useTooltip(content, options) {
    var _placement = options.placement, placement = _placement === void 0 ? "auto" : _placement, _trigger = options.trigger, trigger = _trigger === void 0 ? "hover" : _trigger, _arrowPadding = options.arrowPadding, arrowPadding = _arrowPadding === void 0 ? 16 : _arrowPadding, _tooltipPadding = options.tooltipPadding, tooltipPadding = _tooltipPadding === void 0 ? {
        left: 16,
        right: 16
    } : _tooltipPadding, _tooltipOffset = options.tooltipOffset, tooltipOffset = _tooltipOffset === void 0 ? [
        0,
        10
    ] : _tooltipOffset, _hideTimeout = options.hideTimeout, hideTimeout = _hideTimeout === void 0 ? 100 : _hideTimeout;
    var ref = (0,react.useState)(null), targetElement = ref[0], setTargetElement = ref[1];
    var ref1 = (0,react.useState)(null), tooltipElement = ref1[0], setTooltipElement = ref1[1];
    var ref2 = (0,react.useState)(null), arrowElement = ref2[0], setArrowElement = ref2[1];
    var ref3 = (0,react.useState)(false), visible = ref3[0], setVisible = ref3[1];
    var isHoveringOverTooltip = (0,react.useRef)(false);
    var hideTimeoutRef = (0,react.useRef)();
    var hideTooltip = (0,react.useCallback)(function(e) {
        var hide = function hide() {
            e.stopPropagation();
            e.preventDefault();
            setVisible(false);
        };
        if (trigger === "hover") {
            if (hideTimeoutRef.current) {
                window.clearTimeout(hideTimeoutRef.current);
            }
            if (e.target === tooltipElement) {
                isHoveringOverTooltip.current = false;
            }
            if (!isHoveringOverTooltip.current) {
                hideTimeoutRef.current = window.setTimeout(function() {
                    if (!isHoveringOverTooltip.current) {
                        hide();
                    }
                }, hideTimeout);
            }
        } else {
            hide();
        }
    }, [
        tooltipElement,
        trigger,
        hideTimeout
    ]);
    var showTooltip = (0,react.useCallback)(function(e) {
        e.stopPropagation();
        e.preventDefault();
        setVisible(true);
        if (trigger === "hover") {
            if (e.target === targetElement) {
                // If we were about to close the tooltip and got back to it
                // then prevent closing it.
                clearTimeout(hideTimeoutRef.current);
            }
            if (e.target === tooltipElement) {
                isHoveringOverTooltip.current = true;
            }
        }
    }, [
        tooltipElement,
        targetElement,
        trigger
    ]);
    var toggleTooltip = (0,react.useCallback)(function(e) {
        e.stopPropagation();
        setVisible(!visible);
    }, [
        visible
    ]);
    // Trigger = hover
    (0,react.useEffect)(function() {
        if (targetElement === null || trigger !== "hover") return undefined;
        if ((0,isTouchDevice/* default */.Z)()) {
            targetElement.addEventListener("touchstart", showTooltip);
            targetElement.addEventListener("touchend", hideTooltip);
        } else {
            targetElement.addEventListener("mouseenter", showTooltip);
            targetElement.addEventListener("mouseleave", hideTooltip);
        }
        return function() {
            targetElement.removeEventListener("touchstart", showTooltip);
            targetElement.removeEventListener("touchend", hideTooltip);
            targetElement.removeEventListener("mouseenter", showTooltip);
            targetElement.removeEventListener("mouseleave", showTooltip);
        };
    }, [
        trigger,
        targetElement,
        hideTooltip,
        showTooltip
    ]);
    // Keep tooltip open when cursor moves from the targetElement to the tooltip
    (0,react.useEffect)(function() {
        if (tooltipElement === null || trigger !== "hover") return undefined;
        tooltipElement.addEventListener("mouseenter", showTooltip);
        tooltipElement.addEventListener("mouseleave", hideTooltip);
        return function() {
            tooltipElement.removeEventListener("mouseenter", showTooltip);
            tooltipElement.removeEventListener("mouseleave", hideTooltip);
        };
    }, [
        trigger,
        tooltipElement,
        hideTooltip,
        showTooltip
    ]);
    // Trigger = click
    (0,react.useEffect)(function() {
        if (targetElement === null || trigger !== "click") return undefined;
        targetElement.addEventListener("click", toggleTooltip);
        return function() {
            return targetElement.removeEventListener("click", toggleTooltip);
        };
    }, [
        trigger,
        targetElement,
        visible,
        toggleTooltip
    ]);
    // Handle click outside
    (0,react.useEffect)(function() {
        if (trigger !== "click") return undefined;
        var handleClickOutside = function handleClickOutside(param) {
            var target = param.target;
            if ((0,_instanceof/* default */.Z)(target, Node)) {
                if (tooltipElement != null && targetElement != null && !tooltipElement.contains(target) && !targetElement.contains(target)) {
                    setVisible(false);
                }
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            return document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        trigger,
        targetElement,
        tooltipElement
    ]);
    // Trigger = focus
    (0,react.useEffect)(function() {
        if (targetElement === null || trigger !== "focus") return undefined;
        targetElement.addEventListener("focus", showTooltip);
        targetElement.addEventListener("blur", hideTooltip);
        return function() {
            targetElement.removeEventListener("focus", showTooltip);
            targetElement.removeEventListener("blur", hideTooltip);
        };
    }, [
        trigger,
        targetElement,
        showTooltip,
        hideTooltip
    ]);
    // On small screens Popper.js tries to squeeze the tooltip to available space without overflowing beyond the edge
    // of the screen. While it works fine when the element is in the middle of the screen it does not handle well the
    // cases when the target element is very close to the edge of the screen - no margin is applied between the tooltip
    // and the screen edge.
    // preventOverflow mitigates this behaviour, default 16px paddings on left and right solve the problem for all screen sizes
    // that we support.
    // Note that in the farm page where there are tooltips very close to the edge of the screen this padding works perfectly
    // even on the iPhone 5 screen (320px wide), BUT in the storybook with the contrived example ScreenEdges example
    // iPhone 5 behaves differently overflowing beyond the edge. All paddings are identical so I have no idea why it is,
    // and fixing that seems like a very bad use of time.
    var ref4 = (0,usePopper/* usePopper */.D)(targetElement, tooltipElement, {
        placement: placement,
        modifiers: [
            {
                name: "arrow",
                options: {
                    element: arrowElement,
                    padding: arrowPadding
                }
            },
            {
                name: "offset",
                options: {
                    offset: tooltipOffset
                }
            },
            {
                name: "preventOverflow",
                options: {
                    padding: tooltipPadding
                }
            }, 
        ]
    }), styles = ref4.styles, attributes = ref4.attributes;
    var tooltip = /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTooltip, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, animationMap), {
        variants: animationVariants,
        transition: {
            duration: 0.3
        },
        ref: setTooltipElement,
        style: styles.popper
    }), attributes.popper), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_browser_esm/* ThemeProvider */.f6, {
                theme: invertTheme,
                children: content
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow, {
                ref: setArrowElement,
                style: styles.arrow
            })
        ]
    }));
    var AnimatedTooltip = /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyMotion/* LazyMotion */.X, {
        features: features_animation/* domAnimation */.H,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
            children: visible && tooltip
        })
    });
    var portal = (0,getPortalRoot/* default */.Z)();
    var tooltipInPortal = portal ? /*#__PURE__*/ (0,react_dom.createPortal)(AnimatedTooltip, portal) : null;
    return {
        targetRef: setTargetElement,
        tooltip: tooltipInPortal !== null && tooltipInPortal !== void 0 ? tooltipInPortal : AnimatedTooltip,
        tooltipVisible: visible
    };
};
/* harmony default export */ var useTooltip_useTooltip = (useTooltip);


/***/ }),

/***/ 52891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51071);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36544);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97114);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17634);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95963);
/* harmony import */ var utils_formatBalance__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65044);






var AvailableReward = function(param) {
    var reward = param.reward, penaltyAppliedReward = param.penaltyAppliedReward, penaltyPercent = param.penaltyPercent, lastRewardAt = param.lastRewardAt;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    var candyToken = _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_2__/* .cronosTokens.candy */ .R7.candy;
    var ref = (0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                children: t("Available reward: %reward%", {
                    reward: "".concat((0,utils_formatBalance__WEBPACK_IMPORTED_MODULE_4__/* .getBalanceNumber */ .mW)(reward, candyToken.decimals).toLocaleString("en-US", {
                        maximumFractionDigits: 5
                    }), " ").concat(candyToken.symbol)
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                children: [
                    t("Earned since your last claim"),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                mb: "4px",
                children: new Date(lastRewardAt * 1000).toLocaleString()
            }),
            penaltyPercent > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        children: [
                            t("If you claim now"),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        children: t("%penaltyPercent%% early claim penalty fee applied, and you get %penaltyAppliedReward% only.", {
                            penaltyPercent: penaltyPercent / 100,
                            penaltyAppliedReward: "".concat((0,utils_formatBalance__WEBPACK_IMPORTED_MODULE_4__/* .getBalanceNumber */ .mW)(penaltyAppliedReward, candyToken.decimals).toLocaleString("en-US", {
                                maximumFractionDigits: 5
                            }), " ").concat(candyToken.symbol)
                        })
                    })
                ]
            })
        ]
    }), {
        placement: "bottom-start"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                ref: targetRef,
                children: [
                    (0,utils_formatBalance__WEBPACK_IMPORTED_MODULE_4__/* .getBalanceNumber */ .mW)(reward, candyToken.decimals).toLocaleString("en-US", {
                        maximumFractionDigits: 5
                    }),
                    " ",
                    candyToken.symbol
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AvailableReward);


/***/ }),

/***/ 3558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36544);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97114);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17634);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95963);




var EarlyClaimFee = function(param) {
    var penaltyStart = param.penaltyStart, penaltyDelta = param.penaltyDelta, penaltyPercent = param.penaltyPercent;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var ref = (0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                bold: true,
                mb: "4px",
                children: t("Early claim fee: %fee%%", {
                    fee: penaltyPercent / 100
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: t("Starts from %penaltyStart%%, decreases %penaltyDelta%% everyday. Timer resets every time you claim rewards from the lock.", {
                    penaltyStart: penaltyStart / 100,
                    penaltyDelta: penaltyDelta / 100
                })
            })
        ]
    }), {
        placement: "bottom-start"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                ref: targetRef,
                small: true,
                textTransform: "lowercase",
                children: [
                    penaltyPercent / 100,
                    "% early claim penalty fee"
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EarlyClaimFee);


/***/ }),

/***/ 89267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36544);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97114);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17634);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95963);




var EarlyUnlockFee = function(param) {
    var lockAt = param.lockAt, duration = param.duration, epochTime = param.epochTime;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var unlockPenaltyFee = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return Math.max(0, Math.floor((duration - epochTime + lockAt) * 10000 / duration) / 100);
    }, [
        lockAt,
        duration,
        epochTime
    ]);
    var ref = (0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: t("Locked since %lockAt%", {
                    lockAt: new Date(lockAt * 1000).toLocaleString()
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: t("Locked for %duration% days", {
                    duration: Math.floor(duration / 3600 / 24)
                })
            }),
            unlockPenaltyFee > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: t("If you unlock now, %unlockPenaltyFee%% early unlock penalty fee will be applied", {
                    unlockPenaltyFee: unlockPenaltyFee
                })
            })
        ]
    }), {
        placement: "bottom-start"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                ref: targetRef,
                small: true,
                textTransform: "lowercase",
                children: [
                    unlockPenaltyFee,
                    "% early unlock penalty fee"
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EarlyUnlockFee);


/***/ }),

/***/ 38473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44431);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(bignumber_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var config_abi_candyLockV2_json__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6023);
/* harmony import */ var config_constants_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97971);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64011);
/* harmony import */ var utils_addressHelpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96273);
/* harmony import */ var utils_bigNumber__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35128);
/* harmony import */ var utils_wagmi__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69330);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62039);














// Retrieve Lock configuration
var useLockConfig = function() {
    var chainId = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().chainId;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        aprRates: {},
        boostRates: {},
        minToken: utils_bigNumber__WEBPACK_IMPORTED_MODULE_7__/* .BIG_ZERO */ .HW,
        maxNft: 0,
        penaltyStart: 0,
        penaltyDelta: 0
    }), conf = ref[0], setConf = ref[1];
    var candyLockV2Address = (0,utils_addressHelpers__WEBPACK_IMPORTED_MODULE_6__/* .getCandyLockV2Address */ .O$)(chainId);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var fetchConfiguration = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var client, contractCalls, result;
                return _root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            client = (0,utils_wagmi__WEBPACK_IMPORTED_MODULE_8__/* .publicClient */ .z2)({
                                chainId: chainId
                            });
                            contractCalls = Object.keys(_types__WEBPACK_IMPORTED_MODULE_9__/* .LockDuration */ .v).slice(0, 4).map(function(duration) {
                                return {
                                    abi: config_abi_candyLockV2_json__WEBPACK_IMPORTED_MODULE_3__,
                                    address: candyLockV2Address,
                                    functionName: "aprPerDuration",
                                    args: [
                                        duration
                                    ]
                                };
                            }).concat(Object.keys(config_constants_types__WEBPACK_IMPORTED_MODULE_4__/* .Rarity */ .uq).slice(0, 5).map(function(rarity) {
                                return {
                                    abi: config_abi_candyLockV2_json__WEBPACK_IMPORTED_MODULE_3__,
                                    address: candyLockV2Address,
                                    functionName: "boostPerRarity",
                                    args: [
                                        rarity
                                    ]
                                };
                            }), [
                                {
                                    abi: config_abi_candyLockV2_json__WEBPACK_IMPORTED_MODULE_3__,
                                    address: candyLockV2Address,
                                    functionName: "minTokenPerLock",
                                    args: []
                                },
                                {
                                    abi: config_abi_candyLockV2_json__WEBPACK_IMPORTED_MODULE_3__,
                                    address: candyLockV2Address,
                                    functionName: "maxNftPerLock",
                                    args: []
                                },
                                {
                                    abi: config_abi_candyLockV2_json__WEBPACK_IMPORTED_MODULE_3__,
                                    address: candyLockV2Address,
                                    functionName: "penaltyConf",
                                    args: []
                                }
                            ]);
                            _ctx.next = 4;
                            return client.multicall({
                                contracts: contractCalls,
                                allowFailure: false
                            });
                        case 4:
                            result = _ctx.sent;
                            setConf({
                                aprRates: result.slice(0, 4).reduce(function(acc, elem, index) {
                                    // eslint-disable-next-line
                                    // @ts-ignore
                                    var acc_ = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, Object.values(_types__WEBPACK_IMPORTED_MODULE_9__/* .LockDuration */ .v)[index], Number(elem)));
                                    return acc_;
                                }, {}),
                                boostRates: result.slice(4, 9).reduce(function(acc, elem, index) {
                                    // eslint-disable-next-line
                                    // @ts-ignore
                                    var acc_ = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, Object.keys(config_constants_types__WEBPACK_IMPORTED_MODULE_4__/* .Rarity */ .uq)[index], Number(elem)));
                                    return acc_;
                                }, {}),
                                minToken: new (bignumber_js__WEBPACK_IMPORTED_MODULE_2___default())(result[9].toString()),
                                maxNft: Number(result[10]),
                                penaltyStart: Number(result[11][0]),
                                penaltyDelta: Number(result[11][1])
                            });
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchConfiguration() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchConfiguration();
    }, [
        candyLockV2Address,
        chainId
    ]);
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, conf);
};
/* harmony default export */ __webpack_exports__["Z"] = (useLockConfig);


/***/ }),

/***/ 68657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44431);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(bignumber_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var config_abi_candyLockV2_json__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6023);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64011);
/* harmony import */ var hooks_useRefreshEffect__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27892);
/* harmony import */ var utils_addressHelpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96273);
/* harmony import */ var utils_bigNumber__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35128);
/* harmony import */ var utils_wagmi__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69330);












// Retrieve reward from lock
var useLockReward = function(lockId) {
    var chainId = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().chainId;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), deps = ref[0], setDeps = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        reward: utils_bigNumber__WEBPACK_IMPORTED_MODULE_7__/* .BIG_ZERO */ .HW,
        penaltyPercent: 0,
        penaltyAppliedReward: utils_bigNumber__WEBPACK_IMPORTED_MODULE_7__/* .BIG_ZERO */ .HW
    }), value = ref1[0], setValue = ref1[1];
    var candyLockV2Address = (0,utils_addressHelpers__WEBPACK_IMPORTED_MODULE_6__/* .getCandyLockV2Address */ .O$)(chainId);
    (0,hooks_useRefreshEffect__WEBPACK_IMPORTED_MODULE_5__/* .useSlowRefreshEffect */ .X)(function() {
        var fetchLockReward = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var client, rewardResult, reward, penaltyPercent, penaltyAppliedReward;
                return _root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            client = (0,utils_wagmi__WEBPACK_IMPORTED_MODULE_8__/* .publicClient */ .z2)({
                                chainId: chainId
                            });
                            _ctx.next = 3;
                            return client.readContract({
                                abi: config_abi_candyLockV2_json__WEBPACK_IMPORTED_MODULE_3__,
                                address: candyLockV2Address,
                                functionName: "pendingReward",
                                args: [
                                    lockId
                                ]
                            });
                        case 3:
                            rewardResult = _ctx.sent;
                            reward = new (bignumber_js__WEBPACK_IMPORTED_MODULE_2___default())(rewardResult[0].toString());
                            penaltyPercent = Number(rewardResult[1].toString());
                            penaltyAppliedReward = new (bignumber_js__WEBPACK_IMPORTED_MODULE_2___default())(rewardResult[2].toString());
                            setValue({
                                reward: reward,
                                penaltyPercent: penaltyPercent,
                                penaltyAppliedReward: penaltyAppliedReward
                            });
                        case 8:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchLockReward() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchLockReward();
    }, [
        candyLockV2Address,
        chainId,
        lockId,
        deps
    ]);
    var fetchUpdates = function() {
        setDeps(!deps);
    };
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, value), {
        fetchUpdates: fetchUpdates
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (useLockReward);


/***/ }),

/***/ 26762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var hooks_useCallWithGasPrice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71228);
/* harmony import */ var hooks_useContract__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16583);





var useLockToken = function() {
    var callWithGasPrice = (0,hooks_useCallWithGasPrice__WEBPACK_IMPORTED_MODULE_2__/* .useCallWithGasPrice */ .d)().callWithGasPrice;
    var lockV2Contract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_3__/* .useCandyLockV2Contract */ .MR)();
    var onLock = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(amount, duration, nftIds, rarities, proofs) {
            return _root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", callWithGasPrice(lockV2Contract, "lock", [
                            amount,
                            duration,
                            nftIds,
                            rarities,
                            proofs
                        ]));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(amount, duration, nftIds, rarities, proofs) {
            return _ref.apply(this, arguments);
        };
    }(), [
        lockV2Contract,
        callWithGasPrice
    ]);
    var onBuy = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(lid) {
            return _root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", callWithGasPrice(lockV2Contract, "buy", [
                            lid
                        ]));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(lid) {
            return _ref.apply(this, arguments);
        };
    }(), [
        lockV2Contract,
        callWithGasPrice
    ]);
    var onClaim = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(lid) {
            return _root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", callWithGasPrice(lockV2Contract, "claimReward", [
                            lid
                        ]));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(lid) {
            return _ref.apply(this, arguments);
        };
    }(), [
        lockV2Contract,
        callWithGasPrice
    ]);
    var onUnlock = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(lid) {
            return _root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", callWithGasPrice(lockV2Contract, "unlock", [
                            lid
                        ]));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(lid) {
            return _ref.apply(this, arguments);
        };
    }(), [
        lockV2Contract,
        callWithGasPrice
    ]);
    var onTransfer = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(lid, newOwner) {
            return _root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", callWithGasPrice(lockV2Contract, "transfer", [
                            lid,
                            newOwner
                        ]));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(lid, newOwner) {
            return _ref.apply(this, arguments);
        };
    }(), [
        lockV2Contract,
        callWithGasPrice
    ]);
    var onList = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(lid, price) {
            return _root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", callWithGasPrice(lockV2Contract, "list", [
                            lid,
                            price
                        ]));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(lid, price) {
            return _ref.apply(this, arguments);
        };
    }(), [
        lockV2Contract,
        callWithGasPrice
    ]);
    var onDelist = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(lid) {
            return _root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", callWithGasPrice(lockV2Contract, "delist", [
                            lid
                        ]));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(lid) {
            return _ref.apply(this, arguments);
        };
    }(), [
        lockV2Contract,
        callWithGasPrice
    ]);
    return {
        onBuy: onBuy,
        onClaim: onClaim,
        onDelist: onDelist,
        onList: onList,
        onLock: onLock,
        onTransfer: onTransfer,
        onUnlock: onUnlock
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useLockToken);


/***/ })

}]);